import React from 'react';

import OnboardingTermsAndConditionsScene from '../onboarding/onboarding-terms-and-conditions/onboarding-terms-and-conditions-scene';
import useOnboardingTermsAndConditions from '../onboarding/onboarding-terms-and-conditions/use-onboarding-terms-and-conditions';
import OnboardingBackground from 'assets/images/onboarding-background.webp';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: any) => ({
  container: {
    backgroundColor: theme.palette.primary.main,
    backgroundImage: `url(${OnboardingBackground})`,
  }
}
));

const TermsOfService = () => {
  const classes = useStyles();
  const {
    t,
    theme,
    tabIndex,
    setTabIndex,
  } = useOnboardingTermsAndConditions();

  const handleTabChange = (_: React.ChangeEvent<{}>, value: any) => setTabIndex(value);

  const a11yProps = (index: number) => ({
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  });

  return (
    <Grid className={classes.container}>
      <OnboardingTermsAndConditionsScene
        t={t}
        theme={theme}
        a11yProps={a11yProps}
        tabIndex={tabIndex}
        handleTabChange={handleTabChange}
        userAgreed={false}
        handleUserAgreed={() => { }}
        handleAgreement={() => { }}
        hideActions
      />
    </Grid>
  );
};

export default TermsOfService;
